<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title :title="title+'详情'"></pt-page-title>
    <pt-sub-title :title="title+'信息'"></pt-sub-title>
    <table  :class="$style['sign-notes-detail']">
      <pt-message-table-item label="活动名称" v-if="this.signDetail.type !== 'PARSE'">
        {{notesDetail.eventName}}
      </pt-message-table-item>
      <template v-for="(item,index) in fieldsArr">
      <pt-message-table-item v-if="!item.hidden || isTwentiethSurvey" :label="item.label" :key="index">
        {{itemData(data,item)}}
        <!-- {{notesDetail[item.key]}} -->
      </pt-message-table-item>
      </template>
      <template v-if="signDetail.existsOptions">
      <pt-message-table-item  :label="signDetail.optionName">
          {{userOption.remark?userOption.remark:"--"}}
        </pt-message-table-item>
        <pt-message-table-item label="定金" v-if="signDetail.userOption&&signDetail.userOption.deposit" >
          {{notesDetail.promotion_amount?notesDetail.promotion_amount:"--"}}
        </pt-message-table-item>
      </template>
      <pt-message-table-item label="报名时间">
        {{notesDetail.registration_time}}
      </pt-message-table-item>
       <pt-message-table-item label="状态">
         <span :class="$style['signStatus']" v-if="showStatus(notesDetail)" @click="changeStatus(notesDetail)">{{notesDetail.sign_status}}</span>
         <span v-else>{{notesDetail.sign_status}}</span>
      </pt-message-table-item>
      <template v-if="notesDetail.activityCode === 'REPORT_INTERPRET'">
        <pt-message-table-item label="地区">
          {{notesDetail.area }}
        </pt-message-table-item>
        <pt-message-table-item label="已分配人员">
          {{notesDetail.allotUserName }}
        </pt-message-table-item>
        <pt-message-table-item label="解读完成时间">
          {{notesDetail.unscramble_date }}
        </pt-message-table-item>
      </template>
      <template v-if="notesDetail.status==='CANCEL'">
      <pt-message-table-item label="取消操作员">
        {{(notesDetail.operationalInformation && notesDetail.operationalInformation.name)||'--'}}
      </pt-message-table-item>
      <pt-message-table-item label="取消时间">
        {{notesDetail.cancel_time||'--'}}
      </pt-message-table-item>
      <pt-message-table-item label="取消原因">
        {{notesDetail.canCellReason||'--'}}
      </pt-message-table-item>
      </template>
      <pt-message-table-item label="查看报告" v-if="isViewReport">
        <template v-if="reportUrls&&reportUrls.length===2">
        <div v-for="(item,index) in reportUrls" @click="viewReport(item.url)" :key="index" :class="$style['reportUrl']">{{item.name+(index===0?'(上)':"(下)")}}</div>
        </template>
        <template v-else>
          <div v-for="(item,index) in reportUrls"  @click="viewReport(item.url)" :key="index" :class="$style['reportUrl']">{{item.name+(reportUrls.length>1?"("+index+")":"")}}</div>
        </template>
      </pt-message-table-item>
    </table>
    <pt-sub-title title="解读详情" v-if="notesDetail.readDetailData && notesDetail.readDetailData.length"></pt-sub-title>
    <div :class="$style['specification-table-div']" class="page-background" v-if="notesDetail.readDetailData && notesDetail.readDetailData.length">
      <table :class="$style['specification-table']">
        <th>
          <td>解读人</td>
          <td style="width:15%">解读时间</td>
          <td style="width:60%">解读详情</td>
          <td>操作</td>
        </th>
        <tr v-for="(item,index) in notesDetail.readDetailData" :key="index">
          <td>{{item.userName}}</td>
          <td>{{item.unscrambleDate}}</td>
          <td>{{item.content}}</td>
          <td v-if="item.hasOperation"><el-button @click="edit" type="text">编辑</el-button></td>
          <td v-else>--</td>
        </tr>
      </table>
    </div>
    <div class="button-div" v-if="isShowCancel">
        <el-button type="primary" v-if="showInvalidButton"  @click="invalidSign" :loading="invalidLoding">过期失效</el-button>
        <el-button type="primary" v-if="showCancelButton" @click="cancelSign" :loading="cancelLoading">取消预约</el-button>
    </div>
    <el-dialog title="解读详情" v-if="reportReadDialog" :visible.sync="reportReadDialog">
      <pt-notes-dialog :hasRead="hasRead" @onCancel="onCancel" :id="reportReadId"></pt-notes-dialog>
    </el-dialog>
    <el-dialog title="预约状态变更" v-if="statusDialog" :visible.sync="statusDialog">
      <status-dialog :rowData="rowData" @changeStatusCancel="changeStatusCancel"></status-dialog>
    </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import { itemFiledsData } from '../../utils-filed'
import { hasPermissions } from 'utils/permissions'
import ptNotesDialog from '../pt-notes-dialog/withData'
import statusDialog from '../status-dialog'
import api from '@/api'
const prefixCls = 'pt-notes-detail'
const PERM_REGISTRATION_CANCEL = 'PERM_REGISTRATION_CANCEL'// 是否有取消报名的权限
export default {
  name: 'pt-notes-detail',
  components: { ptNotesDialog, statusDialog },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    data () {
      return (this.notesDetail.genericFormData && this.notesDetail.genericFormData.data) || {}
    },
    userOption () {
      return this.notesDetail.userOption || {}
    },
    fieldsArr () {
      return (this.signDetail && this.signDetail.form && this.signDetail.form.fields) || []
    },
    HAS_PERM_REGISTRATION_CANCEL () { // 是否有取消报名的权限
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_REGISTRATION_CANCEL)
    },
    activityCode () {
      return this.signDetail.rule && this.signDetail.rule.activityCode
    },
    // 是否显示取消按钮
    isShowCancel () {
      return this.HAS_PERM_REGISTRATION_CANCEL && this.notesDetail.status === 'SUCCESS' && this.isShowCancelOfLifeExperienceHall && this.isShowCancelOfReport
    },
    // 是生命体验馆类型的报名，是否显示取消按钮
    isShowCancelOfLifeExperienceHall () {
      return this.activityCode === 'LIFE_EXPERIENCE_HALL' ? this.notesDetail.workflowStatus !== 'SIGNED_IN' : true
    },
    // 在报告预约解读类型中，是否显示取消按钮
    isShowCancelOfReport () {
      return this.activityCode === 'REPORT_INTERPRET' ? this.notesDetail.workflowStatus !== 'INTERPRETED' : true
    },
    title () {
      return this.signDetail.type === 'PARSE' ? '报告预约解读' : '活动报名'
    },
    acriveName () {
      return this.signDetail.type === 'PARSE' ? '名称' : '活动名称'
    },
    showInvalidButton () {
      return this.activityCode === 'REPORT_INTERPRET' && this.notesDetail.status === 'SUCCESS' && (this.notesDetail.workflowStatus === 'UNCONFIRMED' || this.notesDetail.workflowStatus === 'CONFIRMED')
    },
    // 是否可查看报告
    isViewReport () {
      return this.signDetail.type === 'PARSE'
    },
    showCancelButton () {
      return this.activityCode !== 'REPORT_INTERPRET'
    },
    // 是否是20周年调查问卷
    isTwentiethSurvey () {
      return this.activityCode === 'TWENTIETH_SURVEY'
    }
  },
  props: {
    id: {
      type: String
    },
    notesDetail: {
      type: Object
    },
    cancelLoading: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    signDetail: {
      type: Object
    },
    signId: {
      type: String
    },
    invalidLoding: {
      type: Boolean
    }
  },
  data () {
    return {
      reportUrls: [],
      reportReadDialog: false,
      reportReadId: '',
      hasRead: true,
      statusDialog: false,
      rowData: {}
    }
  },
  watch: {
    data: {
      handler: function (val) {
        if (val.complexSampleData && val.complexSampleData.length) {
          val.complexSampleData.forEach(item => {
            this.getSampleRecordUrl(item.url, item.name)
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    invalidSign () {
      this.$emit('invalidSign')
    },
    cancelSign () {
      this.$emit('cancelSign')
    },
    itemData (data, val) {
      return itemFiledsData(data, val) || '--'
    },
    getSampleRecordUrl (reportUrl, name) {
      this.$http.get(api.api_server + '/mallsales/api/user/reports/' + this.data.sampleRecordId + '/get-url?ossUrl=' +
          reportUrl).then(url => {
        if (url.data) {
          // 去重
          let hasUrl = false
          this.reportUrls = []
          this.reportUrls.forEach(item => {
            if (item.url === url.data) {
              hasUrl = true
            }
          })
          if (!hasUrl) {
            this.reportUrls.push({ url: url.data, name: name })
          }
        }
      }).catch(err => {
        console.error(err)
      })
    },
    viewReport (url) {
      location.href = url
    },
    edit () {
      this.reportReadDialog = true
      this.reportReadId = this.notesDetail.id
    },
    onCancel () {
      this.reportReadDialog = false
      this.$emit('signNotesDetail')
    },
    showStatus (row) {
      return row.activityCode === 'REPORT_INTERPRET' && row.status === 'SUCCESS' && (row.workflowStatus === 'UNCONFIRMED' || row.workflowStatus === 'CONFIRMED')
    },
    // 改变状态
    changeStatus (row) {
      this.statusDialog = true
      this.rowData = row
    },
    changeStatusCancel () {
      this.statusDialog = false
      this.$emit('signNotesDetail')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.sign-notes-detail{
   padding: 0 20px;
   .signStatus{
     cursor: pointer;
     color: #edbe81;
   }
}
.reportUrl{
  color: #273768;
  text-decoration:underline
}
.specification-table-div{
    margin: 20px 0;
    padding: 10px 20px 30px;
  }
.specification-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row!important;
        padding: 0!important;
        list-style-type:none;
        justify-content:center!important;
        border-bottom: 1px solid #C6C9D3;
        color: #5B5B5B!important;
    }
    th td{
      color: #edbe81!important;
    }
    td{
        color: #5B5B5B!important;
        text-align: left;
        justify-content:flex-start!important;
        padding: 10px;
    }
  }
</style>
